import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-peach-soft" data-id="element-331" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-16" data-id="element-332" data-mp="2bvcry7v3o8gz">
        <p className="text-sm font-semibold text-peach-deep" data-id="element-333" data-mp="1x06ljjs3e7n4">Launch offer</p>
        <h2 className="mt-3 font-display text-2xl font-semibold text-navy sm:text-4xl" data-id="element-334" data-mp="21y85e6xceazn">The launch price ends in:</h2>
        <div className="mt-6" data-id="element-335" data-mp="1o6tlzyziw7s2">
          <Countdown data-id="element-336" data-mp="1o5ikk5tjvc44" />
        </div>
        <p className="mt-5 text-sm text-navy-soft" data-id="element-337" data-mp="1sxti520tilti">
          After that the price goes up by <span className="font-bold text-peach-deep" data-id="element-338" data-mp="1szwj2h3idzd0">$63</span> and stays there.
        </p>
      </div>
    </section>;
}